<template>
  <div class="container-header">
    <div class="warm-info" v-if="false">
        <p class="content">
            <span>This site was designed with the meshere.com website builder. Create your website today.</span>
            <a class="btn start-now">Start Now</a>
        </p>
    </div>
    <div class="login-bar" v-if="navShow" :style="{opacity: opacity}" id="login-bar">
        <v-login></v-login>
    </div>  
    
    <div v-if="navShow" :style="{opacity: opacity}" id="nav-bar">
        <v-nav></v-nav>
    </div>    
  </div>
</template>

<script>
import jQuery from 'jquery'
import Nav from '@/modules/header/nav.vue'
import Login from '@/modules/header/login.vue'
// import FadeAnimation from '@/animat/fadeAnimation.vue'
export default {
  name: 'Header',
  components:{
      'v-nav': Nav,
      'v-login': Login
  },
  data () {
    return {
      navShow: true,
      opacity: 1,
      flag: false
    }
  },
  mounted(){
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy(){
      window.removeEventListener("scroll", this.handleScroll);
  },
  destroyed(){

  },
  methods:{
    handleScroll(){
        let intervalTimer = 0;
        let timeoutTimer = 0;
        if(this.flag) return;
        if(jQuery(window).width() < 800) return;
        if (window.pageYOffset > 250) {
            jQuery('#nav-bar').fadeOut()
            jQuery('#login-bar').fadeOut()
        }else{
            jQuery('#nav-bar').fadeIn()
            jQuery('#login-bar').fadeIn()
        }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.container-header{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background: #ffffff;
    z-index: 5;
    @media screen and (min-width: 800px){
      min-width: 1000px;
    }
    @media screen and (max-width:$media-max-width){
      
    }
  .warm-info{
      font-family: 'GothamLight';
      font-weight: bold;
      font-size: 14px;
      text-align: center;
      padding: 5px 0;
      background: #eff1f2;
      border-bottom: 3px solid #ba0c2f;
      @media screen and (max-width:$media-max-width){
        font-size: 12px;
        padding: 15px 10px;
        border-bottom: 1px solid #ba0c2f;
      }
        .content{
            display: -webkit-flex;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .btn{
            font-size: 14px;
            color: #ba0c2f;
            border: 1px solid #ba0c2f;
            display: inline-flex;
            width: 112px;
            height: 35px;
            justify-content: center;
            align-items: center;
            border-radius: 17px;
            flex-shrink: 0;
            text-align: center;
            cursor: pointer;
            margin-left: 5px;
            transition: all .7s;
            @media screen and (max-width:$media-max-width){
              width: 70px;
              height: 23px;
              font-size: 12px;
            }
            &:hover{
                background: #ba0c2f;
                color: #ffffff;
            }
        }
  }

  .login-bar{
    @media screen and (max-width: 800px){
                  display: none;
              }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/header/index.vue